class ProductBundle extends HTMLElement {
  constructor() {
    super();

    this.listItem = this.querySelectorAll('.bundle-product-item');
    this.form = this.querySelector('form');
    this.boundMainVariantUpdate = this.onMainProductVariantUpdate.bind(this);
    this.boundVariantInputChange = this.onMainVariantInputChange.bind(this);

    this.updateBundleText();
    this.syncMainProductVariant();
    this.updateBundleTotalPrice();

    this.form.addEventListener('change', this.onVariantChange.bind(this));
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    document.addEventListener(window.MainEvents?.variantUpdate || 'variant:update', this.boundMainVariantUpdate);
    document.addEventListener('change', this.boundVariantInputChange);

    if (this.querySelector('.card--block-title')) {
      this.querySelectorAll('.card--block-title').forEach((checkbox) => {
        checkbox.addEventListener('click', this.onHandleCheckedProduct.bind(this));
      });

      document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    if (this.querySelector('.bundle-product-toggle')) {
      this.querySelectorAll('.bundle-product-toggle').forEach((button) => {
        button.addEventListener('click', this.onHandleToggleProduct.bind(this));
      });

      document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    if (this.querySelector('.bundle-option-close')) {
      this.querySelectorAll('.bundle-option-close').forEach((button) => {
        button.addEventListener('click', this.onHandleCloseProduct.bind(this));
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener(window.MainEvents?.variantUpdate || 'variant:update', this.boundMainVariantUpdate);
    document.removeEventListener('change', this.boundVariantInputChange);
  }

  onVariantChange(event) {
    this.changeSwatch(event);
    this.updateVariants(event);
  }

	  async onSubmitHandler(event) {
	    event.preventDefault();
	    if (this.bundleAddInFlight) return;

	    this.syncMainProductVariant();

	    const btnAddTocart = this.querySelector('[data-bundle-addtocart]');
	    const productId = typeof meta == 'object' ? meta.product.id : this.form.querySelector('[name="product-id"]')?.value;
	    const bundleItem = [...this.querySelectorAll('.bundle-product-item.isChecked')];
	    const cartItems = this.getBundleCartItems(bundleItem);
	    const bundleTrackingBase = this.getBundleTrackingDetail(btnAddTocart);

	    if (!cartItems.length) {
	      this.showBundleMessage('Choose at least one item to add.', 'error');
	      return;
	    }

	    this.dispatchBundleTrackingEvent('evolova:cart-add-click', bundleTrackingBase);
	    this.setBundleSubmitting(true);

	    try {
	      const addResponse = await fetch(this.getJsonRoute(window.routes?.cart_add_url, '/cart/add'), {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          Accept: 'application/json',
	        },
	        body: JSON.stringify({ items: cartItems }),
	      });

	      const responseData = await addResponse.json().catch(() => ({}));
	      if (!addResponse.ok) {
	        throw new Error(responseData?.description || responseData?.message || 'Unable to add bundle to cart.');
	      }

	      let bundleDiscountApplied = false;
	      if (bundleItem.length == this.form.querySelectorAll('.bundle-product-item').length) {
	        try {
	          await this.updateBundleDiscount(productId, bundleItem);
	          bundleDiscountApplied = true;
	        } catch (discountError) {
	          console.warn('Bundle discount update failed after cart add.', discountError);
	        }
	      }

	      this.showBundleMessage('Added. Taking you to cart...', 'success');
	      this.dispatchBundleTrackingEvent('evolova:cart-add-success', {
	        ...bundleTrackingBase,
	        source: 'bundle_cart_add_redirect',
	        response: {
	          ...responseData,
	          id: bundleTrackingBase.variantId,
	          variant_id: bundleTrackingBase.variantId,
	          quantity: bundleTrackingBase.quantity,
	          product_id: productId,
	          bundle_discount_applied: bundleDiscountApplied,
	        },
	      });

	      window.setTimeout(() => {
	        this.redirectTo(window.routes?.cart_url || '/cart');
	      }, 160);
	    } catch (err) {
	      console.error(err);
	      this.setBundleSubmitting(false);
	      this.showBundleMessage(err?.message || 'Unable to add bundle. Please try again.', 'error');
	      this.dispatchBundleTrackingEvent('evolova:cart-add-error', {
	        ...bundleTrackingBase,
	        reason: 'bundle_cart_add_error',
	        message: err?.message || String(err),
	      });
	    }
	  }

  onHandleCheckedProduct(event) {
    event.preventDefault();
    const thisElement = event.currentTarget;
    const item = event.target.closest('.bundle-product-item');
    const id = item.getAttribute('data-bundle-product-item-id');

    const itemElement = this.querySelector(`[data-bundle-product-item-id="${id}"]`);

    if (!itemElement.classList.contains('isChecked')) {
      itemElement.classList.add('isChecked');
      item.classList.add('isChecked');
      thisElement.querySelector('input').setAttribute('checked', true);
    } else {
      itemElement.classList.remove('isChecked');
      item.classList.remove('isChecked');
      thisElement.querySelector('input').removeAttribute('checked');
    }

    this.updateBundleTotalPrice();
  }

  onHandleToggleProduct(event) {
    event.preventDefault();

    this.listItem.forEach((item) => {
      if (item.contains(event.target)) {
        if (!item.classList.contains('is-open')) {
          item.classList.add('is-open');
          this.updateVariants(event);
        } else {
          item.classList.remove('is-open');
        }
      } else {
        item.classList.remove('is-open');
      }
    });
  }

  onHandleCloseProduct(event) {
    event.preventDefault();

    var item = event.currentTarget.closest('.bundle-product-item');

    item.classList.remove('is-open');
  }

  updateBundleText(showBundleText = true) {
    if (showBundleText) {
      const bundlePrice = this.querySelector('.bundle-price');
      const discountText = this.querySelector('.bundle-product-text');
      const discountRate = this.getBundleDiscountRate();

      if (bundlePrice && discountText && discountRate > 0) {
        const discountPercent = discountRate * 100;
        const discountLabel = Number.isInteger(discountPercent) ? discountPercent : discountPercent.toFixed(1);
        const discountTemplate = discountText.dataset.bundleTemplate || discountText.textContent;

        discountText.dataset.bundleTemplate = discountTemplate;
        discountText.innerHTML = discountTemplate.replace('[discount]', discountLabel);
        discountText.style.display = 'block';
      } else if (discountText) {
        discountText.style.display = 'none';
      }
    }
  }

  getBundleDiscountRate() {
    const bundlePrice = this.querySelector('.bundle-price');
    if (!bundlePrice) return 0;

    const discountRate = parseFloat(bundlePrice.getAttribute('data-bundle-discount-rate'));
    return Number.isFinite(discountRate) ? discountRate : 0;
  }

  getCurrentMainVariantId() {
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    if (urlVariantId) return urlVariantId;

    return document.querySelector('product-info input.product-variant-id[name="id"], form[action*="/cart/add"] input.product-variant-id[name="id"]')?.value;
  }

  getMainBundleItem() {
    return this.querySelector('.bundle-product-item');
  }

  onMainProductVariantUpdate(event) {
    const variant = event.detail?.resource;
    if (!variant?.id) return;

    const eventProductId = String(event.detail?.data?.productId || '');
    const mainProductId = String(this.getMainBundleItem()?.dataset.bundleProductItemId || '');
    if (eventProductId && mainProductId && eventProductId !== mainProductId) return;

    this.syncMainProductVariant(variant.id, variant);
  }

  onMainVariantInputChange(event) {
    if (!event.target.matches('input.product-variant-id[name="id"]')) return;

    this.syncMainProductVariant(event.target.value);
  }

  syncMainProductVariant(variantId = this.getCurrentMainVariantId(), variantData = null, updateTotal = true) {
    const item = this.getMainBundleItem();
    if (!item || !variantId) return false;

    const selectElement = item.querySelector('select[name=group_id]');
    if (!selectElement) return false;

    const option = Array.from(selectElement.options).find((selectOption) => String(selectOption.value) === String(variantId));
    if (!option || option.disabled) return false;

    selectElement.value = String(variantId);
    const price = parseFloat(option.getAttribute('data-price'));
    if (Number.isFinite(price)) {
      this.updateBundleCardPrice(item, price, variantData?.compare_at_price);
    }

    if (updateTotal) this.updateBundleTotalPrice();
    return true;
  }

  updateBundleCardPrice(item, price, compareAtPrice = null) {
    const formattedPrice = Shopify.formatMoney(price, window.money_format);
    const priceContainer = item.querySelector('.card--bundle .price');
    const visiblePriceNodes = item.querySelectorAll(
      '.card--bundle .price__regular .price-item--regular, .card--bundle .price__sale .price-item--sale, .card--bundle .price-item--last'
    );

    visiblePriceNodes.forEach((priceNode) => {
      priceNode.innerHTML = formattedPrice;
    });

    if (priceContainer) {
      priceContainer.classList.remove('price--on-sale', 'price--no-compare');
      priceContainer.classList.add('evo-bundle-price-synced');
      priceContainer.setAttribute('data-evo-current-variant-price', formattedPrice);
    }

    const compareAtNode = item.querySelector('.card--bundle .price__sale .price-item--regular');
    if (compareAtNode && compareAtPrice && compareAtPrice > price) {
      compareAtNode.innerHTML = Shopify.formatMoney(compareAtPrice, window.money_format);
      compareAtNode.closest('.price__sale')?.style.removeProperty('display');
    }
  }

  getBundleItemPrice(item) {
    const selectElement = item.querySelector('select[name=group_id]');
    const inputElement = item.querySelector('input[name=group_id]');

    if (selectElement) {
      return parseFloat(selectElement.options[selectElement.selectedIndex]?.getAttribute('data-price') || 0);
    }

    if (inputElement) {
      return parseFloat(inputElement.getAttribute('data-price') || 0);
    }

    return parseFloat(item.querySelector('input[name=id]')?.getAttribute('data-price') || 0);
  }

  updateBundleTotalPrice(showBundleTotalPrice = true) {
    if (showBundleTotalPrice) {
      this.syncMainProductVariant(this.getCurrentMainVariantId(), null, false);

      const bundleItem = this.querySelectorAll('.bundle-product-item.isChecked');
      const maxProduct = this.listItem.length;
      const bundlePrice = this.querySelector('.bundle-price');
      const oldPrice = this.querySelector('.bundle-old-price');
      const totalPriceElement = this.querySelector('[data-bundle-product-total]');
      const addToCartButton = this.querySelector('[data-bundle-addtocart]');
      const discountRate = this.getBundleDiscountRate();

      var totalPrice = 0;

      if (bundleItem.length > 0) {
        bundleItem.forEach((item) => {
          const price = this.getBundleItemPrice(item);

          if (Number.isFinite(price)) {
            totalPrice = totalPrice + parseFloat(price);
          }
        });

        if (bundlePrice && oldPrice && totalPriceElement && discountRate > 0 && bundleItem.length == maxProduct) {
          oldPrice.innerHTML = Shopify.formatMoney(totalPrice, window.money_format);
          bundlePrice.innerHTML = Shopify.formatMoney(totalPrice * (1 - discountRate), window.money_format);
          bundlePrice.style.display = 'inline-block';
          oldPrice.style.display = 'inline-block';
          totalPriceElement.style.display = 'none';
        } else {
          if (bundlePrice) bundlePrice.style.display = 'none';
          if (oldPrice) oldPrice.style.display = 'none';
          if (totalPriceElement) {
            totalPriceElement.style.display = 'block';
            totalPriceElement.innerHTML = Shopify.formatMoney(totalPrice, window.money_format);
          }
        }

        if (addToCartButton) {
          if (bundleItem.length == maxProduct) {
            addToCartButton.value = window.total_btn.add_all_item;
          } else if (bundleItem.length > 2) {
            addToCartButton.value = window.total_btn.add_items.replace('[item]', bundleItem.length);
          } else {
            addToCartButton.value = window.total_btn.add_item.replace('[item]', bundleItem.length);
          }
        }
      } else {
        if (addToCartButton) addToCartButton.value = window.total_btn.add_item.replace('[item]', bundleItem.length);
        if (totalPriceElement) totalPriceElement.innerHTML = Shopify.formatMoney(totalPrice, window.money_format);
        if (bundlePrice) bundlePrice.style.display = 'none';
        if (oldPrice) oldPrice.style.display = 'none';
      }
    }
  }

  updateVariants(event) {
    const item = event.target.closest('.bundle-product-item');
    const productId = item.getAttribute('data-bundle-product-item-id');
    const variants = window.productVariants[productId];
    const fieldsets = event.target.closest('.bundle-product-item').querySelectorAll('.variant-option');

    let selectedOption1;
    let selectedOption2;
    let selectedOption3;

    if (variants) {
      if (fieldsets[0]) selectedOption1 = Array.from(fieldsets[0].querySelectorAll('input')).find((radio) => radio.checked).value;
      if (fieldsets[1]) selectedOption2 = Array.from(fieldsets[1].querySelectorAll('input')).find((radio) => radio.checked).value;
      if (fieldsets[2]) selectedOption3 = Array.from(fieldsets[2].querySelectorAll('input')).find((radio) => radio.checked).value;

      var checkStatus = (optionSoldout, optionUnavailable, swatch) => {
        if (optionSoldout == undefined) {
          if (optionUnavailable == undefined) {
            swatch.classList.add('soldout');
            swatch.setAttribute('disabled', true);
          } else {
            swatch.classList.add('soldout');
            swatch.setAttribute('disabled', true);
          }
        } else {
          swatch.classList.remove('soldout');
          swatch.removeAttribute('disabled');
        }
      };

      var renderSwatch = (optionIndex, element) => {
        const swatchs = element.querySelectorAll('input[type=radio]');

        swatchs.forEach((swatch) => {
          const swatchVal = swatch.getAttribute('value');

          const optionSoldout = variants.find((variant) => {
            switch (optionIndex) {
              case 0: return variant.option1 == swatchVal && variant.available;
              case 1: return variant.option1 == selectedOption1 && variant.option2 == swatchVal && variant.available;
              case 2: return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == swatchVal && variant.available;
            }
          });

          const optionUnavailable = variants.find((variant) => {
            switch (optionIndex) {
              case 0: return variant.option1 == swatchVal;
              case 1: return variant.option1 == selectedOption1 && variant.option2 == swatchVal;
              case 2: return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == swatchVal;
            }
          });

          checkStatus(optionSoldout, optionUnavailable, swatch);
        });
      };

      fieldsets.forEach((element) => {
        const optionIndex = parseInt(element.getAttribute('data-option-idx'));

        renderSwatch(optionIndex, element);
      });
    }
  }

  changeSwatch(event) {
    const item = event.target.closest('.bundle-product-item');
    const fieldsets = Array.from(item.querySelectorAll('.variant-option'));
    const productId = item.getAttribute('data-bundle-product-item-id');
    const variantList = window.productVariants[productId];
    const optionIndex = parseInt(event.target.closest('[data-option-idx]').getAttribute('data-option-idx'));
    const swatches = Array.from(item.querySelectorAll('.swatch-element'));
    const thisValue = event.target.value;
    const productPrice = item.querySelector('.card--bundle .price');
    const priceSale = productPrice.querySelector('.price-sale');
    const priceOld = productPrice.querySelector('.old-price');
    const priceRegular = productPrice.querySelector('.price-item');
    const productInput = item.querySelector('[name=group_id]');
    const hotStock = item.querySelector('.bundle-hotStock');

    let selectedVariant;
    let selectedSwatchOption1;
    let selectedSwatchOption2;
    let selectedSwatchOption3;

    if (fieldsets[0]) selectedSwatchOption1 = Array.from(fieldsets[0].querySelectorAll('input')).find((radio) => radio.checked).value;
    if (fieldsets[1]) selectedSwatchOption2 = Array.from(fieldsets[1].querySelectorAll('input')).find((radio) => radio.checked).value;
    if (fieldsets[2]) selectedSwatchOption3 = Array.from(fieldsets[2].querySelectorAll('input')).find((radio) => radio.checked).value;

    swatches.forEach((swatche) => {
      swatche.classList.remove('soldout');
      swatche.querySelector('input').setAttribute('disabled', false);
    });

    switch (optionIndex) {
      case 0:
        var availableVariants = variantList.find((variant) => {
          return variant.option1 == thisValue && variant.option2 == selectedSwatchOption2 && variant.available;
        });

        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        } else {
          var altAvailableVariants = variantList.find((variant) => {
            return variant.option1 == thisValue && variant.available;
          });

          selectedVariant = altAvailableVariants;
        }

        break;
      case 1:
        var availableVariants = variantList.find((variant) => {
          return variant.option1 == selectedSwatchOption1 && variant.option2 == thisValue && variant.available;
        });

        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        } else {
          console.log('Bundle Error: variant was soldout, on option selection #2');
        }

        break;
      case 2:
        var availableVariants = variantList.find((variant) => {
          return variant.option1 == selectedSwatchOption1 && variant.option2 == selectedSwatchOption2 && variant.option3 == thisValue && variant.available;
        });

        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        } else {
          console.log('Bundle Error: variant was soldout, on option selection #3');
        }

        break;
    }

    productInput.value = selectedVariant.id;
    priceRegular.innerHTML = Shopify.formatMoney(selectedVariant.price, window.money_format);
    if (selectedVariant.compare_at_price > selectedVariant.price) {
      priceRegular.classList.add('special-price');

      if (priceOld) {
        priceOld.innerHtml = Shopify.formatMoney(selectedVariant.compare_at_price, window.money_format);
        priceOld.style.display = 'inline-block';
      }
    } else {
      if (priceOld) {
        priceOld.style.display = 'none';
      }

      priceRegular.classList.remove('special-price');
    }

    item.querySelector('select').value = selectedVariant.id;

    this.updateBundleTotalPrice();

    if (selectedVariant.inventory_management != null) {
      if (hotStock) {
        var arrayInVarName = 'bundle_inven_array_' + productId,
          inven_array = window[arrayInVarName],
          maxStock = parseInt(hotStock.getAttribute('data-bundle-hot-stock'));

        if (inven_array != undefined) {
          var inven_num = inven_array[selectedVariant.id],
            inventoryQuantity = parseInt(inven_num);
        }

        if (inventoryQuantity > 0 && inventoryQuantity <= maxStock) {
          var textStock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);

          hotStock.innerText = textStock;
          hotStock.style.display = 'block';
        } else {
          hotStock.style.display = 'none';
        }
      }
    }

    if (selectedVariant.featured_image) {
      const productImage = this.querySelector(`[data-bundle-product-item-id="${productId}"] img`);

      productImage.setAttribute('src', selectedVariant.featured_image.src);
      productImage.setAttribute('srcset', selectedVariant.featured_image.src);
    }
  }

  onBodyClickEvent(event) {
    if (this.querySelector('.bundle-product-item.is-open')) {
      this.listItem.forEach((item) => {
        if (!item.contains(event.target)) {
          item.classList.remove('is-open');
        }
      });
    }
  }

  isRunningInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

	  getBundleCartItems(bundleItems = [...this.querySelectorAll('.bundle-product-item.isChecked')]) {
	    return bundleItems.map((item) => {
	      const variantInput = item.querySelector('[name=group_id]');
	      const variantId = variantInput?.value;

	      if (!variantId) return null;

	      return {
	        id: Number(variantId),
	        quantity: 1,
	      };
	    }).filter((item) => item && Number.isFinite(item.id));
	  }

	  async updateBundleDiscount(productId, bundleItems) {
	    if (!this.querySelector('[data-bundle-discount-rate]')) return;

	    const discountCode = `FBT-BUNDLE-${productId}`;
	    const bundleDiscountRate = parseFloat(this.querySelector('[data-bundle-discount-rate]').dataset.bundleDiscountRate);
	    if (!Number.isFinite(bundleDiscountRate) || bundleDiscountRate <= 0) return;

	    const cartResponse = await fetch(this.getJsonRoute(window.routes?.cart_url, '/cart'), {
	      headers: { Accept: 'application/json' },
	    });
	    const cartData = cartResponse.ok ? await cartResponse.json().catch(() => ({})) : {};
	    const attributes = cartData?.attributes || {};
	    const items = bundleItems.map((item) => parseInt(item.dataset.bundleProductItemId, 10)).filter(Number.isFinite);
	    const newAttributes = {
	      ...attributes,
	      checkout_level_applications: [{ name: discountCode, bundleDiscountRate, items }],
	    };

	    localStorage.setItem('storedDiscount', discountCode);

	    await Promise.all([
	      fetch(this.getJsonRoute(window.routes?.cart_update_url, '/cart/update'), {
	        method: 'POST',
	        body: JSON.stringify({ attributes: newAttributes }),
	        headers: {
	          'Content-Type': 'application/json',
	          Accept: 'application/json',
	        },
	      }),
	      fetch(`/discount/${discountCode}?redirect=cart`),
	    ]);
	  }

	  setBundleSubmitting(isSubmitting) {
	    const button = this.querySelector('[data-bundle-addtocart]');
	    const wrapper = this.querySelector('form>div');

	    this.bundleAddInFlight = isSubmitting;
	    if (wrapper) wrapper.classList.toggle('has-halo-block-loader', isSubmitting);
	    if (!button) return;

	    if (isSubmitting) {
	      button.dataset.idleValue = button.value;
	      button.value = window.variantStrings?.addingToCart || 'Adding...';
	      button.disabled = true;
	      button.setAttribute('aria-disabled', 'true');
	      button.classList.add('loading');
	      this.showBundleMessage('Adding your setup...', 'status');
	    } else {
	      button.value = button.dataset.idleValue || button.value;
	      button.disabled = false;
	      button.removeAttribute('aria-disabled');
	      button.classList.remove('loading');
	    }
	  }

	  getJsonRoute(route, fallback) {
	    const path = route || fallback;
	    return path.endsWith('.js') ? path : `${path}.js`;
	  }

	  showBundleMessage(message, state = 'status') {
	    let statusNode = this.querySelector('[data-bundle-status]');
	    if (!statusNode) {
	      const action = this.querySelector('.bundle-product-action');
	      if (!action) return;

	      statusNode = document.createElement('p');
	      statusNode.className = 'bundle-product-action__status';
	      statusNode.setAttribute('data-bundle-status', '');
	      statusNode.setAttribute('role', 'status');
	      statusNode.setAttribute('aria-live', 'polite');
	      action.appendChild(statusNode);
	    }

	    statusNode.hidden = !message;
	    statusNode.textContent = message || '';
	    statusNode.dataset.state = state;
	  }

	  redirectTo(url) {
	    if (this.isRunningInIframe() && !window.iframeSdk && !Shopify.designMode) {
	      window.top.location = url;
	    } else {
	      window.location = url;
	    }
	  }

	  getBundleTrackingDetail(target) {
	    const items = this.getBundleTrackingItems();
	    const mainVariantInput = this.form?.querySelector('[name="id"], [name="product-id"]');
	    const firstItem = items[0];
	    return {
	      form: this.form,
	      target,
	      variantId: firstItem?.variant_id || mainVariantInput?.value || '',
	      quantity: Math.max(1, items.reduce((sum, item) => sum + (Number(item.quantity) || 1), 0) || 1),
	      sourceArea: 'bundle',
	      source: 'fbt_bundle',
	      itemListName: 'fbt_bundle',
	      itemListId: 'fbt_bundle',
	      actionId: this.createBundleActionId(firstItem?.variant_id || mainVariantInput?.value || 'bundle'),
	      items,
	    };
	  }

	  getBundleTrackingItems() {
	    return [...this.querySelectorAll('.bundle-product-item.isChecked')].map((item, index) => {
	      const variantInput = item.querySelector('[name=group_id]');
	      const selectedOption = variantInput?.selectedOptions?.[0] || null;
	      const productNode = variantInput || selectedOption || item;
	      const productCard = item.querySelector('[data-product-id], [data-product-title], [data-product-handle]');
	      const titleFallback = item.querySelector('.card__heading, .card-product-title, h3, h4, h5')?.textContent || `Bundle item ${index + 1}`;
	      const variantId = variantInput?.value || selectedOption?.value || '';
	      const price = selectedOption?.dataset?.price || variantInput?.dataset?.price || productCard?.dataset?.price || '';
	      const variantTitle = selectedOption?.dataset?.variantTitle || variantInput?.dataset?.variantTitle || (selectedOption?.textContent || '').split(' - ')[0].trim();
	      const productTitle = productNode?.dataset?.productTitle || productCard?.dataset?.productTitle || titleFallback;

	      return {
	        item_id: String(variantId),
	        variant_id: String(variantId),
	        product_id: String(productNode?.dataset?.productId || productCard?.dataset?.productId || item.dataset.bundleProductItemId || ''),
	        product_handle: String(productNode?.dataset?.productHandle || productCard?.dataset?.productHandle || ''),
	        item_name: String(productTitle || '').trim(),
	        item_variant: String(variantTitle || ''),
	        item_brand: 'Evolova',
	        item_category: 'bundle_item',
	        price,
	        quantity: 1,
	        item_list_name: 'fbt_bundle',
	        item_list_id: 'fbt_bundle',
	        index: index + 1,
	      };
	    }).filter((item) => item.item_id);
	  }

	  createBundleActionId(seed) {
	    return [
	      'bundle',
	      seed || 'unknown',
	      Date.now(),
	      Math.random().toString(36).slice(2, 8),
	    ].join(':');
	  }

	  dispatchBundleTrackingEvent(name, detail = {}) {
	    try {
	      document.dispatchEvent(new CustomEvent(name, { detail }));
	    } catch (e) {
	      // Tracking must never block bundle add-to-cart.
	    }
	  }
	}

customElements.define('product-bundle', ProductBundle);
